module.exports = __webpack_public_path__ + "img/heart.246350d3.svg";